import { render } from "./ReportWaiter.vue?vue&type=template&id=0fd529f4"
import script from "./ReportWaiter.vue?vue&type=script&lang=js"
export * from "./ReportWaiter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__